import React from 'react';
import { Row, Col, Typography } from 'antd';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    ResponsiveContainer,
} from 'recharts';
import styled from 'styled-components';

const { Title } = Typography;

const ChartCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  height: 100%;
`;

const GenderIconBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const GenderPercentage = styled.div`
  font-size: 24px;
  font-weight: 800;
  color: #00c2ff;
`;

const FemaleIcon = () => (
    <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="20" r="12" fill="#00C2FF" />
        <path d="M16 56C16 42.75 23.16 32 32 32C40.84 32 48 42.75 48 56V60H16V56Z" fill="#00C2FF" />
    </svg>
);

const MaleIcon = () => (
    <svg width="60" height="60" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="20" r="12" fill="#00C2FF" />
        <path d="M20 32H44V56C44 58.21 42.21 60 40 60H24C21.79 60 20 58.21 20 56V32Z" fill="#00C2FF" />
    </svg>
);

const PatientStats = ({ data }) => {
    const patientsByGender = data?.patientsByGender || [];
    const totalPatients = patientsByGender.reduce((acc, curr) => acc + curr.count, 0);

    const getPercentage = (gender) => {
        if (!totalPatients) return '0%';
        const found = patientsByGender.find(g => g.gender === gender);
        if (!found) return '0%';
        return `${((found.count / totalPatients) * 100).toFixed(1)}%`;
    };

    const femalePercentage = getPercentage('FEMENINO');
    const malePercentage = getPercentage('MASCULINO');

    const patientLocationData = (data?.patientsByCity || []).map(item => ({
        label: item.name,
        value: item.value
    }));

    return (
        <ChartCard>
            <Title level={5} style={{ marginBottom: 20, color: '#334155' }}>Pacientes por Ubicación y Género</Title>
            <Row align="middle" gutter={24}>
                <Col span={14}>
                    <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={patientLocationData.length > 0 ? patientLocationData : [{ label: 'Dato', value: 0 }]} layout="vertical" margin={{ left: -20 }}>
                            <XAxis type="number" hide />
                            <YAxis dataKey="label" type="category" axisLine={false} tickLine={false} style={{ fontSize: 11 }} width={80} />
                            <Bar dataKey="value" fill="#00C2FF" radius={[0, 4, 4, 0]} barSize={15} />
                        </BarChart>
                    </ResponsiveContainer>
                </Col>
                <Col span={10}>
                    <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', height: '100%' }}>
                        <GenderIconBox>
                            <FemaleIcon />
                            <GenderPercentage>{femalePercentage}</GenderPercentage>
                        </GenderIconBox>
                        <GenderIconBox>
                            <MaleIcon />
                            <GenderPercentage style={{ color: '#00D1FF' }}>{malePercentage}</GenderPercentage>
                        </GenderIconBox>
                    </div>
                </Col>
            </Row>
        </ChartCard>
    );
};

export default PatientStats;
